{
  "intro": "Every 受入 (in) and 払出 (out) of second-hand goods — buy-ins, consigned cards, returns. Kept at least 3 years.",
  "readonly": "The 古物台帳 cannot be changed or deleted (古物営業法) — a mistake is fixed by adding a correction row.",
  "not_checked": "The 様式15 / 様式16 layout has not been checked by a 行政書士 yet.",
  "tabs": {
    "label": "What to show",
    "all": "All rows",
    "incomplete": "Missing information"
  },
  "columns": {
    "date": "Date",
    "type": "In / out",
    "item": "Item and marks",
    "quantity": "Qty",
    "price": "Price",
    "counterparty": "From / to",
    "address": "Address",
    "occupation": "Occupation",
    "age": "Age",
    "minor": "under 18",
    "method": "ID checked with",
    "no_method": "No ID check",
    "channel": "How",
    "tax": "Tax treatment",
    "source": "From",
    "reference": "Reference",
    "staff": "Recorded by",
    "correction": "Correction row"
  },
  "entry_type": {
    "receive": "受入 · in",
    "deliver": "払出 · out"
  },
  "counterparty": {
    "individual": "Person",
    "business": "Business"
  },
  "channel": {
    "face_to_face": "対面 · in person",
    "remote": "非対面 · remote"
  },
  "tax": {
    "kobutsu_tokurei": "古物商特例",
    "shogaku_tokurei": "少額特例",
    "transitional_70": "経過措置 80/70 %",
    "qualified_invoice": "適格請求書",
    "not_applicable": "Not a purchase"
  },
  "source": {
    "buylist": "Buy-in",
    "consignment": "Consignment",
    "customer_return": "Customer return"
  },
  "filters": {
    "date": "Date (Japan time)",
    "counterparty": "Name of the person",
    "q": "Card, number or certificate",
    "q_hint": "e.g. 095/069 or 12345678",
    "big": "¥10,000 and more"
  },
  "incomplete": {
    "banner_one": "{{count}} row is missing the 本人確認 or a required field.",
    "banner_other": "{{count}} rows are missing the 本人確認 or a required field.",
    "show": "Show them",
    "fix": "Consignors without 本人確認",
    "missing": "What is missing",
    "none": "Every row is complete."
  },
  "problems": {
    "identity_check_missing": "No 本人確認",
    "counterparty_address_missing": "No address",
    "counterparty_occupation_missing": "No occupation",
    "counterparty_age_missing": "No age",
    "confirmation_method_missing": "How the ID was checked",
    "item_features_missing": "No marks / features"
  },
  "entry": {
    "title": "古物台帳 row",
    "load_failed": "This row could not be loaded.",
    "date": "Date",
    "item": "Item",
    "features": "Marks",
    "category": "Category",
    "quantity": "Quantity",
    "price": "Price",
    "total": "Whole deal",
    "counterparty": "From / to",
    "address": "Address",
    "occupation": "Occupation",
    "age": "Age",
    "method": "ID checked with",
    "channel": "How",
    "tax": "Tax treatment",
    "source": "From",
    "kept_until": "Kept until",
    "corrected_one": "Corrected {{count}} time",
    "corrected_other": "Corrected {{count}} times",
    "corrections": "Corrections"
  },
  "correction": {
    "button": "Add a correction row",
    "title": "Add a correction row",
    "intro": "The original row stays as it is; a new row with the right value and the reason is added.",
    "field": "What was wrong",
    "value": "Right value",
    "reason": "Why",
    "save": "Add the correction",
    "missing": "Type the right value and the reason.",
    "done": "Correction row added.",
    "fields": {
      "itemDescription": "Item",
      "itemFeatures": "Marks",
      "counterpartyName": "Name",
      "counterpartyAddress": "Address",
      "counterpartyOccupation": "Occupation",
      "confirmationMethod": "ID checked with"
    }
  },
  "export": {
    "button": "Export",
    "title": "Export the 古物台帳",
    "intro": "For the police (様式15 / 様式16) or for Excel (CSV).",
    "format": "What",
    "formats": {
      "style15": "様式15 · 受入",
      "style15_hint": "PDF of what came in",
      "style16": "様式16 · 払出",
      "style16_hint": "PDF of what went out",
      "csv": "CSV",
      "csv_hint": "Every row, opens in Excel"
    },
    "range": "Period",
    "presets": {
      "last_month": "Last month",
      "this_month": "This month",
      "custom": "Choose dates"
    },
    "from": "From",
    "to": "To",
    "bad_range": "The start is after the end.",
    "audited": "Every export is recorded (who and when).",
    "not_checked": "The layout has not been checked by a 行政書士 yet.",
    "make_pdf": "Make the PDF",
    "download_csv": "Download CSV",
    "making": "Making the PDF…",
    "open_one": "Open the PDF ({{count}} row)",
    "open_other": "Open the PDF ({{count}} rows)",
    "failed": "The PDF could not be made."
  }
}
